/**
 * Custom JavaScript for Work Authority
 * File: work-authority.js
 * Description: This file contains custom scripts to enhance the functionality and user experience of the Work Authority website.
 */

// Ensure the DOM is fully loaded before executing scripts
document.addEventListener("DOMContentLoaded", function () {});

/** If product page */
if (document.querySelector(".template-product")) {
  /** Compare app styling */
  (function () {
    const CSS = `
    .attribute-value img {
      width: 85% !important;
      max-width: 140px !important;
      height: auto;
    }
  `;

    function applySheet(shadowRoot) {
      // Prefer constructable stylesheets so we can always append last
      if (
        shadowRoot.adoptedStyleSheets &&
        "replaceSync" in CSSStyleSheet.prototype
      ) {
        // Avoid duplicates
        const has = shadowRoot.adoptedStyleSheets.some((s) => s.__compareFix);
        if (!has) {
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(CSS);
          sheet.__compareFix = true;
          shadowRoot.adoptedStyleSheets = [
            ...shadowRoot.adoptedStyleSheets,
            sheet,
          ];
        }
        return;
      }
      // Fallback: <style> tag appended as last child (wins on order)
      let style = shadowRoot.querySelector("style[data-compare-fix]");
      if (!style) {
        style = document.createElement("style");
        style.setAttribute("data-compare-fix", "");
        style.textContent = CSS;
      }
      shadowRoot.appendChild(style);
    }

    function watchShadow(shadowRoot) {
      applySheet(shadowRoot);
      // Re-apply if the component rebuilds its shadow DOM
      new MutationObserver(() => applySheet(shadowRoot)).observe(shadowRoot, {
        childList: true,
        subtree: true,
      });
    }

    function handleElement(el) {
      // If shadowRoot is not ready yet, wait for it
      if (el.shadowRoot) return watchShadow(el.shadowRoot);

      const tryAttach = () =>
        el.shadowRoot && (observer.disconnect(), watchShadow(el.shadowRoot));
      const observer = new MutationObserver(tryAttach);
      observer.observe(el, { childList: true });
      // Also try on the next microtask
      queueMicrotask(tryAttach);
    }

    function scan() {
      document.querySelectorAll("sc-comparison-table").forEach(handleElement);
    }

    // In case the custom element is registered later
    if (window.customElements?.whenDefined) {
      customElements.whenDefined("sc-comparison-table").then(scan);
    }
    // Handle already-present elements
    scan();

    // Pick up tables injected later
    new MutationObserver(scan).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
}
